import React, { Component } from 'react';
function NotFound() {
  return (
    <>
      <div>
        <h1>404 Page Not found</h1>
      </div>
    </>
  );
}
export default NotFound;
